import { StackView, Box, Button } from '@planningcenter/tapestry-react';
import React from 'react';
import colors from '../colors.js';

function DrawerHeader({ children, closeDrawer }) {
    return (React.createElement(StackView, { alignment: "start", axis: "horizontal", color: "foreground", distribution: "space-between", padding: 2, paddingTop: 1 },
        React.createElement(Box, { flex: 1 }, children),
        closeDrawer && (React.createElement(Button, { icon: {
                fill: colors.lightNeutral12,
                name: "general.x",
                size: "md",
            }, onClick: () => closeDrawer(), title: "Close", theme: false, hover: {
                backgroundColor: colors.lightNeutral93,
            }, marginTop: 0.25 }))));
}

export { DrawerHeader };
//# sourceMappingURL=drawer_header.js.map
